import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import React from "react";


export const RouterContaner = () => <RouterProvider router={router} />;
